import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { d: 'M13.77 28.53a5.35 5.35 0 0 1-1-.11 5.26 5.26 0 0 1-4.17-5.24V10.86a7.4 7.4 0 0 1 8.32-7.33 7.53 7.53 0 0 1 6.48 7.59v10.44H22V11.12A6.09 6.09 0 0 0 16.75 5a5.95 5.95 0 0 0-6.7 5.9v12.28a3.73 3.73 0 0 0 6.09 3.06 3.73 3.73 0 0 0 1.36-2.88V11a1.49 1.49 0 0 0-1.72-1.49 1.64 1.64 0 0 0-1.27 1.66v10.39h-1.45V11.13A3.07 3.07 0 0 1 15.57 8a2.94 2.94 0 0 1 3.37 3v12.4a5.17 5.17 0 0 1-1.89 4 5.23 5.23 0 0 1-3.28 1.13z' })
));